export const MAX_USER_PHOTOS = 6;

const toAbsolute = (path) => {
  if (!path) return '';
  const value = String(path).trim();
  if (!value) return '';
  if (/^https?:\/\//i.test(value) || value.startsWith('data:') || value.startsWith('blob:')) {
    return value;
  }
  const base = process.env.REACT_APP_API_BASE_URL || '';
  return `${base}${value.replace(/^\/+/, '')}`;
};

/**
 * The API stores photos in flat columns image1..image6, with "" for empty slots.
 * Returns them as an ordered list of absolute URLs, profile picture first.
 */
export const getUserImages = (user) => {
  if (!user) return [];
  const urls = [];
  for (let i = 1; i <= MAX_USER_PHOTOS; i += 1) {
    const url = toAbsolute(user[`image${i}`]);
    if (url) urls.push(url);
  }
  return urls;
};

export const getPrimaryUserImage = (user, fallback = '') => getUserImages(user)[0] || fallback;
